export default __webpack_public_path__ + "static/media/decompiler.00715903.png";